import React, {Component} from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Checkbox from 'material-ui/Checkbox';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import ArrowForward from 'material-ui-icons/ArrowForward';
import classNames from 'classnames';
import * as _ from 'lodash';
import qs from 'qs';
import {errorStyle} from '../styles';
import {textStyle} from '../styles';
import {underlineStyle} from '../styles';
import {ValidationService} from '../validation.service';

import {RegistrationService} from '../registration.service';
import MaskedTextField from './MaskedTextField';
import {NotificationService} from '../../services/notification.service';
import {LoadingService} from '../../services/loading.service';
import InfoOutline from 'material-ui-icons/InfoOutline';

class RegistrationStep2 extends Component {

  constructor(props) {
    super(props);
    this.registrationService = new RegistrationService();
    this.notificationService = new NotificationService();
    this.validationService = new ValidationService(this.props.intl);
    this.loadingService = new LoadingService();

    this.state = {
      open                   : false,
      affiliationCoverage    : false,
      affiliationCoverageName: '',
      affiliationCoverageId  : '',
      memberInfo             : null,
    };

    // avoid excessive calling to this method
    this.throttledAffiliationCoverages = _.throttle(this.throttledAffiliationCoverages, 1000, {
      leading : false,
      trailing: true
    });
  }

  async componentDidMount() {
    if (_.size(AFFILIATION) > 0) {
      // push it down the call stack
      setTimeout(() => {
        this.props.onChange({
          hasGroupBenefit: 1
        });
      });
    }

    this.props.state.dob && await this.validateDob(this.props.state.dob);
    this.props.state.phone && await this.validatePhone(this.props.state.phone);
    this.props.state.zip && await this.updateZip(this.props.state.zip);
    this.setState({ memberInfo: this.registrationService.parseMemberInfo(MEMBER_INFO)});

    setTimeout(() => {
      $('svg').attr('focusable', false)
    }, 500)
  }

  signup() {
    let patient = this.registrationService.getPatientCreateObject(this.props.state);

    this.registrationService.register({ patient })
      .then((resp) => {
        this.registrationService.sendUtmReferral(resp.parsed.data.patient.id);

        this.props.onChange({
          /*
           resp.parsed.data has the following structure:

           patient:{id: 7513877, first_name: "John", last_name: "Doe", middle_name: null, username: "johndoe110",…}
           token :[true, ["bd9d3f4e-1c6f-4f2f-a1fc-2a5d990d0b8f", "1503014882564v6mp74"]]
           */
          signupRespData: resp.parsed.data
        });
        this.props.goToStep(4);
      })
      .catch(async (resp) => {
        let respJson = await resp.json();
        _.each(respJson, (errorMessages, fieldName) => {
            this.notificationService.error(this.registrationService.parseErrors(errorMessages));
        });
      });
  }

  signupAsHybrid() {
      let patientData = this.props.state;
      patientData.affiliationId = parseInt(AFFILIATION_ID);
      let patient = this.registrationService.getPatientCreateObject(patientData);

      return this.registrationService.register({patient}).then((resp) => {
              this.setState({isLoading: false})

      this.registrationService.sendUtmReferral(resp.parsed.data.patient.id)
      this.props.onChange({
          signupRespData: resp.parsed.data,
      })
      this.props.goToStep(4)
    }).catch(() => {
          this.setState({isLoading: false})
    });
  }

  signUpAsDtc() {
    this.props.onChange({ affiliationId: 96 });
    this.signup();
    this.setState({ open: false });
  }

  signUpAsAffiliationCoverage() {
    this.props.onChange({ affiliationId: this.state.affiliationCoverageId }).then(() => {this.signup();});
    this.setState({ open: false });
  }

  onZipChange(e) {
    e.persist(); // https://facebook.github.io/react/docs/events.html#event-pooling

    let value = e.target.value;
    this.props.onChange({ zip: value });

    this.updateZip(value);
  }

  updateZip(value){
    this.setState({
      validate: _.merge(_.cloneDeep(this.state.validate), {
        zip: this.validationService.isValidZip(value)
      })
    });

    if (value && value.length == 5) {
      this.validateZipcode(value);
      this.throttledAffiliationCoverages(value);
    }
  }

  onPhoneChange(e) {
    let value = e.target.value;
    this.props.onChange({ phone: value });

    this.validatePhone(value)
  }

  validatePhone(value) {
    this.setState({
      validate: _.merge(_.cloneDeep(this.state.validate), {
        phone: this.validationService.isValidPhone(value)
      })
    });
  }

  onDobChange(e) {
    let value = e.target.value;
    this.props.onChange({ dob: value });

    this.validateDob(value)
  }

  validateDob(value) {
    this.setState({
      validate: _.merge(_.cloneDeep(this.state.validate), {
        dob: this.validationService.isValidDate(value)
      })
    });
  }

  async throttledAffiliationCoverages(e) {
    let resp = await this.registrationService.affiliationCoverages(e);
    if (resp.parsed.data.affiliation) {
      this.setState({
        affiliationCoverage: true,
        affiliationCoverageName: resp.parsed.data.affiliation.description,
        affiliationCoverageId: resp.parsed.data.affiliation.id,
        affiliationCoverageLogoUrl: resp.parsed.data.affiliation.branding.logo
      });
    }
  }

  async validateZipcode(value) {
    let resp = await this.registrationService.validZip(value);
    if (resp.parsed.data.zip === false) {
      this.setState({
        validate: _.merge(_.cloneDeep(this.state.validate), {
          zip: {valid: false, errorMessage: 'Not a valid zipcode'}
        })
      });
    }
  }

  canSubmit() {
    return this.registrationService.checkCanSubmit(this.state.validate, this.props.state, [
      'dob',
      'phone',
      'zip',
      'gender',
      'hasGroupBenefit',
    ]) && this.props.state.acceptedTOS === true && !this.props.state.isLoading;
  }

  submit() {
    if (this.props.state.hasGroupBenefit) {
      if (_.size(HYBRID_270) > 0) {
        this.signupAsHybrid();
      } else {
        this.props.goToStep(3);
      }
    }
    else {
      if (this.state.affiliationCoverage) {
        this.setState({ open: true });
      }
      else {
        this.signup();
      }
    }
  }

  getErrorText(fieldName) {
    if (_.get(this.state.validate, fieldName + '.valid', true) || _.isUndefined(_.get(this.state.validate, fieldName + '.valid', undefined)))
      return null;
    else
      return _.get(this.state.validate, fieldName + '.errorMessage', 'Invalid value');
  }

  onGroupBenefitClick(e, value) {
    if (value == 0) {
      this.props.onChange({
        affiliationId              : 96, // DTC
        eligibilityBusinessUnitData: null
      });
    }

    this.props.onChange({ hasGroupBenefit: value });
  }

  onAffiliatedBenefitClick(e, value) {
    this.props.onChange({ hasAffiliatedBenefit: value });
  }

  allowDigitsOnly(e) {
    if (!/[0-9]/.test(e.key) && ['Backspace', 'Tab', 'Enter'].indexOf(e.key) == -1) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  getConfirmationTextForTOS(){
    return (
      <span>
        <FormattedMessage id="agreeToTerms" values={{
          termsLink: <a href={AFFILIATION_TERMS_OF_USE_LINK} target="_blank" id="tos-link"><FormattedMessage id="termsOfService"/></a>, 
          privacyLink: <a href={AFFILIATION_PRIVACY_POLICY_LINK} target="_blank" id="privacy-policy-link"><FormattedMessage id="privacyPolicy"/></a>
        }} />
      </span>
    )
  }

  getProviderTypes() {
    if (PROVIDER_TYPES) {
      return PROVIDER_TYPES
    } else {
      return "Board Certified Doctor, Behavioral Health Provider or Dermatologist"
    }
  }

  affiliationsRender() {
    const {intl} = this.props;
    return (
        <div className="registration-step2 row h-100">
          <div className="col col-12 col-md-6 guide-block guide-block--doctor-blue h-100">
            <h1>{AFFILIATION_DISPLAY_TITLE || <span className="affiliation-display-name"><FormattedMessage id="displayTitle" values={{affiliationName: AFFILIATION_DISPLAY_NAME}} /></span>}</h1>
            <p>{AFFILIATION_DISPLAY_TAGLINE || <FormattedMessage id="displayTagline" />}</p>
            <p>{AFFILIATION_DISPLAY_INFO || <FormattedMessage id="displayInfo" values={{providerTypes: this.getProviderTypes()}}/>}</p>
          </div>

          <div className="col col-12 col-md-6 content-block h-100">
            <h3><FormattedMessage id="subtitle" /></h3>
            <div className="form-content container-fluid flex-grow h-100 p-0 m-0">
              <div className="form-group">
                <MaskedTextField fullWidth={true}
                                 floatingLabelText={<FormattedMessage id="dateOfBirth"/>}
                                 floatingLabelFixed={true}
                                 placeholder="mm/dd/yyyy"
                                 errorText={this.getErrorText('dob')}
                                 value={this.props.state.dob || ''}
                                 onChange={(e) => this.onDobChange(e)}
                                 errorStyle={errorStyle}
                                 mask="99/99/9999"
                                 id="dob"
                                 disabled={this.state.memberInfo ? this.state.memberInfo.dob : false}
                />
              </div>
              <div className="form-group">
                <TextField fullWidth={true}
                           floatingLabelText={<FormattedMessage id="phoneNumber"/>}
                           type="number"
                           min="1"
                           errorText={this.getErrorText('phone')}
                           value={this.props.state.phone || ''}
                           onChange={(e) => this.onPhoneChange(e)}
                           onKeyDown={(e) => this.allowDigitsOnly(e)}
                           errorStyle={errorStyle}
                           id="phone-number"
                />
              </div>
              <div className="form-group">
                <TextField fullWidth={true} floatingLabelText={<FormattedMessage id="zipCode" />} type="number" min="1"
                           errorText={this.getErrorText('zip')}
                           value={this.props.state.zip || ''}
                           onChange={(e) => this.onZipChange(e)}
                           onKeyDown={(e) => this.allowDigitsOnly(e)}
                           errorStyle={errorStyle}
                           id="zip"
                />
              </div>

              <FormControl fullWidth>
                <InputLabel id="gender-label"><FormattedMessage id='gender' /></InputLabel>

                <Select
                  label-id="gender-label"
                  value={this.props.state.gender || ''}
                  onChange={(event) => this.props.onChange({gender: event.target.value})}
                  id="gender"
                >
                  <MenuItem value="Male"><FormattedMessage id="male"/></MenuItem>
                  <MenuItem value="Female"><FormattedMessage id="female" /></MenuItem>
                  <MenuItem value="Non-binary"><FormattedMessage id="nonBinary" /></MenuItem>
                </Select>
              </FormControl>

              {(CHILD_AFFILIATIONS.length > 0) ?
                  <div className={`mt-2`}>
                    {/*<hr className="d-sm-none d-md-block"/>*/}
                    <p><FormattedMessage id="receiveBenefitQuestion" values={{affiliationName: AFFILIATION_DISPLAY_NAME}} /></p>
                    <RadioButtonGroup name="hasAffiliatedBenefit" className="inline-radios-block"
                                      valueSelected={_.get(this.props.state, 'hasAffiliatedBenefit', '')}
                                      onChange={(e, value) => this.onAffiliatedBenefitClick(e, value)}
                    >
                      <RadioButton label={<FormattedMessage id="yesButton"/>}
                                   value={1}
                      />
                      <RadioButton label={<FormattedMessage id="noButton"/>}
                                   value={0}
                      />
                    </RadioButtonGroup>
                  </div>
                  : null}

              <div className="pl-3 tos-block">
                <div className="checkbox-wrapper">
                  <Checkbox
                      label=""
                      checked={this.props.state.acceptedTOS || false}
                      onCheck={(e) => this.props.onChange({acceptedTOS: e.target.checked})}
                      style={{fontSize: 11}}
                      id="tos"
                  />
                </div>
                <div className="desc-wrapper">
                  {this.getConfirmationTextForTOS()}
                </div>
              </div>
            </div>

            <div className="container-fluid form-footer">
              <div className="float-left back">
                <FlatButton label={<FormattedMessage id="backButton" values={{backArrow: "<"}} />}
                            onClick={() => this.props.goToStep(1)}
                            id="back"/>
              </div>
              <div className="float-right">
                <RaisedButton label={this.props.state.hasGroupBenefit && !(_.size(HYBRID_270) > 0) ? <FormattedMessage id="nextButton" /> : <FormattedMessage id="createAccount" />}
                              backgroundColor="#3DD69F"
                              backgroundColor="var(--affiliation-registration-next-button-color)"
                              labelColor="#FFFFFF"
                              onClick={() => this.submit()}
                              className={classNames('raised-button--rounded', { disabled: !this.canSubmit() })}
                              disabled={!this.canSubmit()}
                              id="next"
                />
              </div>
              <Dialog title=""
                      actions={[
                        <FlatButton
                            label={<FormattedMessage id="noButton" />}
                            primary={true}
                            onClick={() => this.signUpAsDtc()}
                            id="dtc-select"
                        />,
                        <FlatButton
                            label={<FormattedMessage id="yesButton" />}
                            primary={true}
                            onClick={() => this.signUpAsAffiliationCoverage()}
                            id="affiliation-select"
                        />,
                      ]}
                      modal={true}
                      open={this.state.open}
              >
                <div className="logo-container"><img src={this.state.affiliationCoverageLogoUrl} alt="logo" width="210"/></div>
                <p>
                  <FormattedMessage id="affiliationCoverageText" values={{affiliationCoverageName: this.state.affiliationCoverageName}} />
                </p>
                <p><FormattedMessage id="affiliationCoverageCTAText" values={{affiliationCoverageName: <strong>{this.state.affiliationCoverageName}</strong> }} /></p>
              </Dialog>
            </div>
          </div>
        </div>
    );
  }

  unaffiliatedRender() {
    return(
        <div className="registration-step2 row h-100">
          <div className="col col-12 col-md-7 guide-block guide-block--doctor-blue h-100">
            <h2 className="welcome" >Welcome to {AFFILIATION_DISPLAY_NAME}.<br />Your anytime, anywhere doctor’s office.</h2>
            <p> Visit a doctor, counselor, psychiatrist or dermatologist by
              phone, secure video, or MDLIVE App. Pediatricians are
              available 24/7, and family members are also eligible. </p>
            <h3 className="register-today" >Register today
              <ArrowForward className="register-arrow" style={{width: 26, height: 26, color: '#ffffff'}} />
            </h3>
          </div>

          <div className="col col-12 col-md-5 content-block h-100">
            <h3 className="get-started">Let's get started</h3>
            <div className="form-content container-fluid flex-grow h-100 p-0 m-0">
              <div className="form-group">
                <MaskedTextField fullWidth={true}
                                 floatingLabelText={<FormattedMessage id="dateOfBirth"/>}
                                 floatingLabelFixed={true}
                                 hintText="mm/dd/yyyy"
                                 errorText={this.getErrorText('dob')}
                                 value={this.props.state.dob || ''}
                                 onChange={(e) => this.onDobChange(e)}
                                 errorStyle={errorStyle}
                                 floatingLabelStyle={textStyle}
                                 hintStyle={textStyle}
                                 underlineStyle={underlineStyle}
                                 mask="99/99/9999"
                                 id="dob"
                />
              </div>
              <div className="form-group">
                <TextField fullWidth={true} floatingLabelText="Phone Number" type="number" min="1"
                           errorText={this.getErrorText('phone')}
                           value={this.props.state.phone || ''}
                           onChange={(e) => this.onPhoneChange(e)}
                           onKeyDown={(e) => this.allowDigitsOnly(e)}
                           errorStyle={errorStyle}
                           floatingLabelStyle={textStyle}
                           underlineStyle={underlineStyle}
                           id="phone-number"
                />
              </div>
              <div className="form-group">
                <TextField fullWidth={true} 
                           floatingLabelText={<FormattedMessage id="zipCode" />} type="number" min="1"
                           errorText={this.getErrorText('zip')}
                           value={this.props.state.zip || ''}
                           onChange={(e) => this.onZipChange(e)}
                           onKeyDown={(e) => this.allowDigitsOnly(e)}
                           errorStyle={errorStyle}
                           floatingLabelStyle={textStyle}
                           underlineStyle={underlineStyle}
                           id="zip"
                />
              </div>

              <FormControl fullWidth>
                <InputLabel id="gender-label"><FormattedMessage id='gender' /></InputLabel>

                <Select
                  label-id="gender-label"
                  value={this.props.state.gender || ''}
                  onChange={(event) => this.props.onChange({gender: event.target.value})}
                  id="gender"
                >
                  <MenuItem value="Male"><FormattedMessage id="male"/></MenuItem>
                  <MenuItem value="Female"><FormattedMessage id="female" /></MenuItem>
                  <MenuItem value="Non-binary"><FormattedMessage id="nonBinary" /></MenuItem>
                </Select>
              </FormControl>

              {_.size(AFFILIATION) == 0 ?
                  <div className={`mt-2`}>
                    {/*<hr className="d-sm-none d-md-block"/>*/}
                    <p><FormattedMessage id="receiveBenefitQuestion" values={{affiliationName: AFFILIATION_DISPLAY_NAME}} /></p>
                    <RadioButtonGroup name="hasGroupBenefit" className="inline-radios-block"
                                      valueSelected={_.get(this.props.state, 'hasGroupBenefit', '')}
                                      onChange={(e, value) => this.onGroupBenefitClick(e, value)}
                    >
                      <RadioButton label="Yes"
                                   value={1}
                      />
                      <RadioButton label="No"
                                   value={0}
                      />
                    </RadioButtonGroup>
                  </div>
                  : null}

              <hr className="d-sm-none d-md-block"/>

              <div className="pl-3 tos-block">
                <div className="checkbox-wrapper">
                  <Checkbox
                      label=""
                      checked={this.props.state.acceptedTOS || false}
                      onCheck={(e) => this.props.onChange({acceptedTOS: e.target.checked})}
                      style={{fontSize: 11}}
                      id="tos"
                  />
                </div>
                <div className="desc-wrapper">
                  {this.getConfirmationTextForTOS()}
                </div>
              </div>
            </div>

            <div className="container-fluid form-footer">
              <div className="float-left back">
                <FlatButton label="< Back"
                            onClick={() => this.props.goToStep(1)}
                            id="back"/>
              </div>
              <div className="float-right">
                <RaisedButton label={this.props.state.hasGroupBenefit ? <FormattedMessage id="nextButton" /> : <FormattedMessage id="createAccount" />}
                              backgroundColor="#0079ff"
                              disabledBackgroundColor="#0079ff"
                              labelColor="#ffffff"
                              disabledLabelColor="#ffffff"
                              onClick={() => this.submit()}
                              className={classNames('raised-button--rounded', { disabled: !this.canSubmit() })}
                              disabled={!this.canSubmit()}
                              id="next"
                />
              </div>
              <Dialog title=""
                      actions={[
                        <FlatButton
                            label={<FormattedMessage id="noButton" />}
                            primary={true}
                            onClick={() => this.signUpAsDtc()}
                            id="dtc-select"
                        />,
                        <FlatButton
                            label={<FormattedMessage id="yesButton" />}
                            primary={true}
                            onClick={() => this.signUpAsAffiliationCoverage()}
                            id="affiliation-select"
                        />,
                      ]}
                      modal={true}
                      open={this.state.open}
              >
                <div className="logo-container"><img src={this.state.affiliationCoverageLogoUrl} alt="logo" width="210"/></div>
                <p>
                <FormattedMessage id="affiliationCoverageText" values={{affiliationCoverageName: this.state.affiliationCoverageName}} />
                </p>
                <p><FormattedMessage id="affiliationCoverageCTAText" values={{affiliationCoverageName: <strong>{this.state.affiliationCoverageName}</strong> }} /></p>
              </Dialog>
            </div>
          </div>
        </div>
    );
  }

  render() {
    // disabled temporarily until we start development
    if (AFFILIATION_ID=='') {
      return (
          this.unaffiliatedRender()
      );
    }

    else {
      return (
          this.affiliationsRender()
      );
    }
  }
}

export default injectIntl(RegistrationStep2);



// WEBPACK FOOTER //
// ./registration-react/components/registration-step2.js